<template>
  <div>
    <van-nav-bar
      title="节日宝"
      left-text="返回"
      left-arrow
      @click-left="$router.push('/member/members')"
    />
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-row>
        <van-col span="8">
          <div class="capital">
            <h5>当前余额</h5>
            <p>{{ account.movableamount }}元</p>
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>已投资额</h5>
            <p>{{ useamount.toFixed(2) }}元</p>
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>当前资产</h5>
            <p>{{ account.amount }}元</p>
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>当月收益</h5>
            <p>{{ account.interestthis }}元</p>
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>上月收益</h5>
            <p>{{ account.interestlast }}元</p>
          </div>
        </van-col>
        <van-col span="8">
          <div class="capital">
            <h5>历史收益</h5>
            <p>{{ account.interestamount }}元</p>
          </div>
        </van-col>
      </van-row>
      <div class="capital-btn">
        <van-row>
          <van-col span="12">
            <van-button round type="danger" size="small" @click="movein.status = true">转入</van-button>
          </van-col>
          <van-col span="12">
            <van-button round type="info" size="small" @click="moveout.status = true">转出</van-button>
          </van-col>
        </van-row>
      </div>
      <van-cell center title="自动转入转出">
        <template #right-icon>
          <van-switch  :active-value= 1 :inactive-value= 0 v-model="account.isautoinout" size="24" @change="setauto" />
        </template>
      </van-cell>
      <div class="hint">
        <h5>温馨提示</h5>
        <p>{{ account.explain1 }}</p>
        <p>{{ account.explain2 }}</p>
      </div>
      <div class="product">
        <h5>近期节日宝产品</h5>
        <div class="productDetails" v-for="(item,index) in Holidaytype" :key="index" @click="chooseHoliday(item)">
          <van-row>
            <van-col span="12"><p>编号:{{ item.orderid }}</p></van-col>
            <van-col span="12"><p>名称:{{ item.name }}</p></van-col>
            <van-col span="12"><p>投资周期:{{ item.period }}</p></van-col>
            <van-col span="12"><p>利息:{{ (Number(item.interest)*100).toFixed(2) }}</p></van-col>
            <van-col span="12"><p>开始时间:{{ item.starttime }}</p></van-col>
            <van-col span="12"><p>结束时间:{{ item.endtime }}</p></van-col>
          </van-row>
        </div>
      </div>
      <van-tabs>
        <van-tab title="当前投资">
          <div class="detailed_box" v-for="(item,index) in currentData" :key="index" @click="closefund(item)">
            <div class="detailed">
              <h5>编号</h5>
              <p>{{ item.order }}</p>
            </div>
            <div class="detailed">
              <h5>投资金额</h5>
              <p>{{ item.amount }}</p>
            </div>
            <div class="detailed">
              <h5>投资周期</h5>
              <p>{{ item.period }}</p>
            </div>
            <div class="detailed">
              <h5>开始时间</h5>
              <p>{{ item.starttime }}</p>
            </div>
            <div class="detailed">
              <h5>结束时间</h5>
              <p>{{ item.endtime }}</p>
            </div>
            <div class="detailed">
              <h5>预计收益</h5>
              <p>{{ item.estimateinterest }}</p>
            </div>
            <div style="clear:both;"></div>
          </div>
        </van-tab>
        <van-tab title="历史投资">
          <div class="detailed_box" v-for="(item,index) in historyData" :key="index">
            <div class="detailed">
              <h5>编号</h5>
              <p>{{ item.order }}</p>
            </div>
            <div class="detailed">
              <h5>投资金额</h5>
              <p>{{ item.amount }}</p>
            </div>
            <div class="detailed">
              <h5>投资周期</h5>
              <p>{{ item.period }}</p>
            </div>
            <div class="detailed">
              <h5>开始时间</h5>
              <p>{{ item.starttime }}</p>
            </div>
            <div class="detailed">
              <h5>结束时间</h5>
              <p>{{ item.endtime }}</p>
            </div>
            <div class="detailed">
              <h5>实际收益</h5>
              <p>{{ item.realinterest }}</p>
            </div>
            <div style="clear:both;"></div>
          </div>
        </van-tab>
        <van-tab title="资金明细">
          <van-cell-group>
            <van-cell title="开始日期" :value="capitalDetails.startDate" @click="capitalDetails.startStatus = true" placeholder="点击选择开始日期" />
<!--            <van-calendar v-model="capitalDetails.status" type="range" :show-confirm="false" @confirm="onConfirmDate" />-->
            <van-popup v-model="capitalDetails.startStatus" position="bottom">
              <van-datetime-picker
                v-model="capitalDetails.date"
                @confirm="onConfirmStartDate"
                @cancel="capitalDetails.startStatus = false"
                type="date"
                title="选择年月日"
              />
            </van-popup>
          </van-cell-group>
          <van-cell-group>
            <van-cell title="结束日期" :value="capitalDetails.endDate" @click="capitalDetails.endStatus = true" placeholder="点击选择结束日期" />
            <van-popup v-model="capitalDetails.endStatus" position="bottom">
              <van-datetime-picker
                v-model="capitalDetails.date"
                @confirm="onConfirmEndDate"
                @cancel="capitalDetails.endStatus = false"
                type="date"
                title="选择年月日"
              />
            </van-popup>

            <!--            <van-calendar v-model="capitalDetails.status" type="range" :show-confirm="false" @confirm="onConfirmDate" />-->
          </van-cell-group>
          <van-button type="primary" block size="small" @click="getCapitalDetails(true)">查询</van-button>
          <van-list
            v-model="capitalDetails.loading"
            :finished="capitalDetails.finished"
            finished-text="没有更多了"
            @load="getCapitalDetails(false)"
          >
            <van-cell-group>
              <van-cell v-for="(item,index) in capitalDetails.data" :key="index">
                <template #title>
                  {{ item.name }}
                </template>
                <template #label>
                  余额:{{ item.balance }}
                </template>
                <template #default>
                  <span>{{ item.amount }}元</span>
                  <br>{{ item.time }}元
                </template>
              </van-cell>
            </van-cell-group>
            <!--            <van-cell v-for="item in list" :key="item" :title="item" />-->
          </van-list>
        </van-tab>
      </van-tabs>
    </van-pull-refresh>
    <van-dialog v-model="holiday.status" title="新建节日宝" show-cancel-button  :beforeClose="createHoliday">
      <van-cell-group>
        <van-field type="digit" v-model="holiday.money" label="节日宝金额" placeholder="请输入存入节日宝金额" />
      </van-cell-group>
    </van-dialog>
    <van-dialog v-model="movein.status" title="转入" show-cancel-button  :beforeClose="moveinBtn">
      <van-cell-group>
        <van-field type="digit" v-model="movein.money" label="转入金额" placeholder="请输入转入金额" />
      </van-cell-group>
    </van-dialog>
    <van-dialog v-model="moveout.status" title="转出" show-cancel-button  :beforeClose="moveoutBtn">
      <van-cell-group>
        <van-field type="digit" v-model="moveout.money" label="转出金额" placeholder="请输入转出金额" />
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
  export default {
    name: "HolidayFund",
    data(){
      return{
        account:{
          amount:'0.00',
          movableamount:'0.00',
          totalamount:'0.00',
          interestamount:'0.00',
          interestthis:'0.00',
          interestlast:'0.00',
          isautoinout:0,
          explain1:'',
          explain2:''
        },
        Holidaytype:[],
        currentData:[],
        historyData:[],
        capitalDetails:{
          date: new Date(),
          startStatus:false,
          startDate:this.$moment().format("YYYY-MM-DD"),
          endStatus:false,
          endDate:this.$moment().format("YYYY-MM-DD"),
          data:[],
          page:1,
          num:20,
          loading:false,
          finished:false
        },
        movein:{
          money:0,
          status:false
        },
        moveout:{
          money:0,
          status:false
        },
        holiday:{
          money: 0,
          tid:0,
          status:false
        },
        isLoading:false
      }
    },
    computed: {
      useamount:function () {
        let that = this;
        return Number(that.account.amount)-Number(that.account.movableamount);
      }
    },
    methods:{
      isLogin(){
        let that = this;
        if (!that.$store.state.loginType){
          that.$router.push('/login')
        }
      },
      getHolidayFund(){
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "holiday_fund",
              token: sessionStorage.getItem("token"),
              action: 'queryfund'
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              /*let resData = res.data;
              let account = resData.data.account;
              switch (account.isautoinout) {
                case 0:
                  account.isautoinout = false;
                  break;
                case 1:
                  account.isautoinout = true;
                  break;
              }
              */
              let resData = res.data;
              that.account = resData.data.account;
              that.Holidaytype = resData.data.Holidaytype;
              that.currentData = resData.data.details;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(res.data.msg);
            }
          });
      },
      getquerydetails(){
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "holiday_fund",
              token: sessionStorage.getItem("token"),
              action: 'querydetails',
              status: '2',
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              let resData = res.data;
              that.historyData = resData.data;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(res.data.msg);
            }
          });
      },
      getCapitalDetails(status){
        let that = this;
        if (status){
          that.capitalDetails.page = 1;
          that.capitalDetails.finished = false;
        }
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "holiday_fund",
              token: sessionStorage.getItem("token"),
              action: 'querylog',
              page: that.capitalDetails.page,
              num:that.capitalDetails.num,
              start: that.capitalDetails.startDate,
              end: that.capitalDetails.endDate
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.capitalDetails.loading = false;
              let resData = res.data;
              let number = resData.data.length;
              if (number < 20){
                that.capitalDetails.finished = true;
              }
              status ? that.capitalDetails.data = that.capitalDetails.data = resData.data : that.capitalDetails.data = that.capitalDetails.data.concat(resData.data);
              let page = that.capitalDetails.page;
              that.capitalDetails.page = page + 1;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(res.data.msg);
            }
          })
          .catch(() => {
              that.capitalDetails.loading = false;
              that.capitalDetails.finished = true;
          });
      },
      createHoliday(action,done){
        let that = this;
        switch (action) {
          case 'confirm':
            let money = parseInt(that.holiday.money);
            if (money <= 0 || isNaN(money)){
              this.$toast({
                type: 'warning',
                message: '请输入正确金额'
              });
              done(false);
            }else{
              that.$http({
                  url: "/",
                  method: "post",
                  data: {
                    nozzle: "holiday_fund",
                    token: sessionStorage.getItem("token"),
                    action: 'createaccount',
                    Holidaytypeid: that.holiday.tid,
                    amount:money
                  }
                })
                .then(function (res) {
                  if (res.data.code == 1) {
                    that.$toast({
                      message: res.data.msg,
                      type: 'success',
                      onClose:function () {
                        that.mainMethod();
                        that.holiday.money = 0;
                        done();
                      }
                    });
                  } else if (res.data.code == 0 || res.data.code == -1) {
                    that.$toast.fail(res.data.msg);
                    done(false);
                  }
                });
            }
            break;
          case 'cancel':
            done();
            break;
        }

      },
      setauto(){
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "holiday_fund",
              token: sessionStorage.getItem("token"),
              action: 'setauto',
              isautoinout: that.account.isautoinout,
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.$toast({
                type:'success',
                message:res.data.msg,
                onClose:function () {
                  that.mainMethod();
                }
              });
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$toast.fail(res.data.msg);
            }
          });
      },
      mainMethod(){
        this.getHolidayFund();
        this.getquerydetails();
        this.getCapitalDetails(true);
      },
      moveoutBtn(action,done){
        let that = this;
        switch (action) {
          case 'confirm':
            let money = parseInt(that.moveout.money);
            if (money <= 0 || isNaN(money)){
              this.$toast({
                type: 'warning',
                message: '请输入正确金额'
              });
              done(false);
            }else{
              that.$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "holiday_fund",
                  token: sessionStorage.getItem("token"),
                  action: 'moveout',
                  amount: money,
                }
              })
                .then(function (res) {
                  if (res.data.code == 1) {
                    that.$toast({
                      message: res.data.msg,
                      type: 'success',
                      onClose:function () {
                        that.mainMethod();
                        that.moveout.money = 0;
                        done();
                      }
                    });
                  } else if (res.data.code == 0 || res.data.code == -1) {
                    that.$toast.fail(res.data.msg);
                    done(false)
                  }
                });
            }
            break;
          case 'cancel':
            done();
            break;
        }

      },
      moveinBtn(action,done){
        let that = this;
        switch (action) {
          case 'confirm':
            let money = parseInt(that.movein.money);
            if (money <= 0 || isNaN(money)){
              this.$toast({
                type: 'warning',
                message: '请输入正确金额'
              });
              done(false);
            }else{
              that.$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: "holiday_fund",
                  token: sessionStorage.getItem("token"),
                  action: 'movein',
                  amount: money,
                }
              }).then(function (res) {
                if (res.data.code == 1) {
                  that.$toast({
                    message: res.data.msg,
                    type: 'success',
                    onClose:function () {
                      that.mainMethod();
                      that.movein.money = 0;
                      done()
                    }
                  });
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$toast.fail(res.data.msg);
                  done(false)
                }
              });
            }
            break;
          case 'cancel':
            done();
            break;
        }

      },
      closefund(data) {
        let that = this;
        that.$dialog.confirm( {
          title: '节日宝结算',
          message: '您的节日宝还没到期,提前结算您将损失所有的利息',
        }).then(() => {
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "holiday_fund",
                token: sessionStorage.getItem("token"),
                action: 'closefund',
                Holidaydetailid: data.id
              }
            })
            .then(function (res) {
              if (res.data.code == 1) {
                let resData = res.data;
                that.$toast({
                  type: 'success',
                  message: resData.msg,
                  onClose: function () {
                    that.mainMethod();
                  }
                });
              } else if (res.data.code == 0 || res.data.code == -1) {
                that.$toast.fail(res.data.msg);
              }
            });
        }).catch(() => {

        });
      },
      onRefresh() {
        this.mainMethod();
        this.isLoading = false;
      },
      chooseHoliday(data){
        this.holiday.tid = data.tid;
        this.holiday.status = true;
      },
      onConfirmDate(date){
        const [start, end] = date;
        this.capitalDetails.status = false;
        this.capitalDetails.showDate = `${this.formatDate(start)} - ${this.formatDate(end)}`;
        this.capitalDetails.date = [this.timeFormat(date[0]),this.timeFormat(date[1])];
      },
      timeFormat(time) {
        let year = time.getFullYear();
        let month = time.getMonth() + 1;
        let day = time.getDate();
        return year + '-' + month + '-' + day
      },
      formatDate(date) {
        return `${date.getMonth() + 1}/${date.getDate()}`;
      },
      onConfirmStartDate(time){
        this.capitalDetails.startDate = this.$moment(time).format("YYYY-MM-DD");
        this.capitalDetails.startStatus = false;
      },
      onConfirmEndDate(time){
        this.capitalDetails.endDate = this.$moment(time).format("YYYY-MM-DD");
        this.capitalDetails.endStatus = false;
      }
    },
    mounted:function () {
      this.isLogin();
      this.getHolidayFund();
      this.getquerydetails();
      this.getCapitalDetails(true);
    }
  }
</script>

<style scoped>
  .capital {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .capital h5 {
    margin: 0;
    color: #999;
    font-size: 14px;
    font-weight: 300;
  }

  .capital p {
    margin: 0;
    color: red;
    font-size: 14px;
    font-weight: bold;
  }

  .capital-btn {
    margin-top: 10px;
    text-align: center;
  }

  .hint {
    width: 90%;
    margin: 10px auto;
  }

  .hint h5 {
    margin: 0;
    font-size: 14px;
    color: #333;
  }

  .hint p {
    margin: 0;
    font-size: 14px;
    color: #333;
  }
  .product{
    width: 90%;
    margin: 0 auto;
  }
  .product h5{
    margin: 0;
    border-bottom: 1px solid #999;
    font-size: 16px;
    color: #999;
    padding-bottom: 10px;
  }
  .productDetails{
    padding-top: 10px;
    border-bottom: 1px solid #999;
  }
  .productDetails p{
    margin: 0;
    font-size: 14px;
    color: #333;
  }
  .detailed_box{
    width: 95%;
    margin: 0 auto;
    border-bottom: 1px solid #999;
    padding-bottom: 10px;
  }
  .detailed{
    margin-top: 10px;
    float: left;
    width: 33.33%;
  }

  .detailed h5 {
    text-align: center;
    margin: 0;
    color: #333;
    font-size: 14px;
  }

  .detailed p {
    text-align: center;
    margin: 0;
    color: #999;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/HolidayFund.vue